module.exports = __webpack_public_path__ + "img/header_top_bg.a7457280.png";